import { z } from 'zod';
import { cnpjValido, cpfValido } from './documento';

export const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
] as const;

const so = (s: string) => s.replace(/\D/g, '');
const obrigatorio = (rotulo: string, max = 120) =>
  z.string().trim().min(1, `Preencha ${rotulo}`).max(max, `${rotulo} está longo demais`);
const opcional = (max = 120) => z.string().trim().max(max).default('');

export const cadastroClienteSchema = z
  .object({
    tipoPessoa: z.enum(['J', 'F'], 'Escolha o tipo de pessoa'),
    nome: obrigatorio('a razão social'),
    fantasia: opcional(),
    documento: z.string().transform(so),
    ie: opcional(30),
    rg: opcional(30),
    telefone: opcional(30),
    celular: z
      .string()
      .transform(so)
      .refine((d) => d.length >= 10 && d.length <= 13, 'Celular inválido'),
    email: z.string().trim().toLowerCase().email('E-mail inválido').max(120),
    cep: z
      .string()
      .transform(so)
      .refine((d) => d.length === 8, 'CEP inválido'),
    municipio: obrigatorio('o município', 80),
    uf: z.enum(UFS, 'Escolha a UF'),
    endereco: obrigatorio('o endereço'),
    bairro: obrigatorio('o bairro', 80),
    numero: obrigatorio('o número', 20),
    complemento: opcional(60),
  })
  .superRefine((d, c) => {
    const ok = d.tipoPessoa === 'J' ? cnpjValido(d.documento) : cpfValido(d.documento);
    if (!ok)
      c.addIssue({
        code: 'custom',
        path: ['documento'],
        message: d.tipoPessoa === 'J' ? 'CNPJ inválido' : 'CPF inválido',
      });
  });
export type CadastroClienteInput = z.input<typeof cadastroClienteSchema>;
export type CadastroCliente = z.output<typeof cadastroClienteSchema>;
